/* eslint-disable import/no-anonymous-default-export */
import { AutoComplete, DatePicker, Form, Input, notification, Select } from "antd";
import { useParams } from "react-router-dom";
import DataSave from "../common/components/DataSave";
import MainLayout from "../common/components/MainLayout";
import  useEquiposProcesamientoAPI, { EquipoProcesamiento, EquipoProcesamientoForm } from "./useEquiposProcesamientoAPI";

import "moment/locale/es-mx";
import locale from "antd/es/date-picker/locale/es_ES";
import moment from "moment";
import { useEffect, useState } from "react";
import { ActionResult } from "../common/hooks/useApi";
import useAgentesAPI, { Agente } from "../agentes/useAgentesAPI";
import useConfiguracionesProduccionAPI, { ConfiguracionProduccion } from "../configuraciones-produccion/useConfiguracionesProduccionAPI";
import TextArea from "antd/lib/input/TextArea";
import { AxiosError } from "axios";

moment.updateLocale("es-mx", {
  week: {
    dow: 1,
  },
});


export default () => {
  const { id } = useParams();
  const api = useEquiposProcesamientoAPI();
  const configuracionesProduccionApi = useConfiguracionesProduccionAPI();
  const agentesApi = useAgentesAPI();
  const [configuracionesProduccionResponse, setConfiguracionesProduccionResponse] =
    useState<ActionResult<ConfiguracionProduccion[]>>();
  const [agentesResponse, setAgentesResponse] =
    useState<ActionResult<Agente[]>>();
  const [categoriasResponse, setCategoriasResponse] = useState<ActionResult<EquipoProcesamiento[]>>();
  const successRoute = "/neuralvision/equipos-procesamiento";

  const onAxiosError = (error: AxiosError) => {
    if (error.response?.data.value == "EquipoProcesamiento.EquipoProcesamientoExistente") {
      notification.error({
        placement: 'bottomRight',
        message: "Nombre de EquipoProcesamiento existente en la unidad de producción"
      })
      return false;
    }
  };

  useEffect(() => {
    configuracionesProduccionApi.list({ $expand: [] }).then(setConfiguracionesProduccionResponse);
    agentesApi.list({}).then(setAgentesResponse);
    api.listCategorias({}).then(setCategoriasResponse);
  }, []);

  return (
    <MainLayout title="Guardar Equipo de procesamiento">
      <DataSave<EquipoProcesamiento, EquipoProcesamiento, EquipoProcesamientoForm>
        list={(query) =>
          api.list({ ...query, ...{ $expand: [] } })
        }
        onAxiosError={onAxiosError}
        save={api.save}
        transformOnLoad={async (value) => ({
          ...value
        })}
        transformOnSave={async (value) => ({
          ...value,
        })}
        id={id}
        successRoute={successRoute}
      >
        <Form.Item
          rules={[{ required: true, message: "Campo requerido" }]}
          required
          name={"Nombre"}
          label="Nombre"
        >
          <Input />
        </Form.Item>


      </DataSave>
    </MainLayout>
  );
};
